import { CreateArchiveSpecification } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/create-archive-specification';
import { Job } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/job';

import { Project } from '../../types/entities';
import { mediaPlatformProvider } from '../media-platform-provider';

const getJob = (
  organizationId: string,
  project: Project,
  jobId: string,
): Promise<Job<CreateArchiveSpecification>> => {
  const jobManager = mediaPlatformProvider.getSDKInstance(
    organizationId,
    project,
  ).jobManager;

  return jobManager.getJob(jobId);
};

export const jobsService = {
  getJob,
};
